module.exports = __webpack_public_path__ + "img/tendering-3@3x.25c9f6b3.png";